import ENV from '../../config/environment';
import { EXTENSIONS_BY_CATEGORY } from '../assets';

const basePath = `${ENV.SH_CDN_STATIC_IMAGES_URL}/assets/icons/`;
const assetsPath = 'assets/';

/**
 * Creates a map of file category names to small and large icon paths.
 *
 * @param {String[]} fileCategories The array of file categories (e.g. 'IMAGE', 'VIDEO', 'TEXT').
 * @returns {Object} The formatted object with all the asset icon paths specified.
 */
function getAssetIcons(fileCategories) {
  const assetIcons = {};

  fileCategories.forEach((category) => {
    assetIcons[category] = {
      SMALL: `${basePath}${assetsPath}${category.toLowerCase()}_small.svg`,
      LARGE: `${basePath}${assetsPath}${category.toLowerCase()}_large.svg`,
    };
  });

  return assetIcons;
}

export default {
  ADD_FOLLOWERS: 'https://res.cloudinary.com/ddsqycvoq/image/upload/v1674075423/web/icons/eye-plus-outline.svg',
  ADD_TO_TEAM: 'https://res.cloudinary.com/ddsqycvoq/image/upload/v1671821650/web/icons/add-to-team.svg',
  ASSIGNMENT_SUBMITTED: `${ENV.SH_CDN_STATIC_IMAGES_URL}/icons/assignment_submitted.svg`,
  DURATION: 'https://res.cloudinary.com/ddsqycvoq/image/upload/v1660838335/web/icons/duration-icon.svg',
  EXPEDITE_PAYMENT: 'https://res.cloudinary.com/ddsqycvoq/image/upload/v1675182789/web/icons/sparkle.svg',
  EXPENSE_REPORT: 'https://res.cloudinary.com/ddsqycvoq/image/upload/v1660838346/web/icons/expensereport-icon.svg',
  FIND_CREATORS: 'https://res.cloudinary.com/ddsqycvoq/image/upload/w_200,h_200/web/find-creators.png',
  FREELANCER_REPORT: `${ENV.SH_CDN_STATIC_IMAGES_URL}/icons/freelancer_report.svg`,
  INVOICE_REPORT: `${ENV.SH_CDN_STATIC_IMAGES_URL}/icons/invoice_report.svg`,
  NETWORK: 'https://res.cloudinary.com/ddsqycvoq/image/upload/v1669828728/web/icons/network-icon.svg',
  PROJECT_REPORT: `${ENV.SH_CDN_STATIC_IMAGES_URL}/icons/project_report.svg`,
  SUBMITTED: `${ENV.SH_CDN_STATIC_IMAGES_URL}/icons/submitted.svg`,
  SEARCH: `${ENV.SH_CDN_STATIC_IMAGES_URL}/icons/search.svg`,
  ASSETS: getAssetIcons(Object.keys(EXTENSIONS_BY_CATEGORY)),
};
